// Animation constants to prevent inline object creation

// Animation offsets
const ANIMATION_Y_OFFSET = 30;
const ANIMATION_X_OFFSET = 30;
const ANIMATION_SCALE_START = 0.95;
const ANIMATION_SCALE_END = 1;

export const fadeInUp = {
  initial: { opacity: 0, y: ANIMATION_Y_OFFSET },
  animate: { opacity: 1, y: 0 },
};

export const fadeInUpDelay = (delay = 0) => ({
  initial: { opacity: 0, y: ANIMATION_Y_OFFSET },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export const fadeInLeft = {
  initial: { opacity: 0, x: -ANIMATION_X_OFFSET },
  animate: { opacity: 1, x: 0 },
};

export const fadeInRight = {
  initial: { opacity: 0, x: ANIMATION_X_OFFSET },
  animate: { opacity: 1, x: 0 },
};

export const scaleIn = {
  initial: { opacity: 0, scale: ANIMATION_SCALE_START },
  animate: { opacity: 1, scale: ANIMATION_SCALE_END },
};

export const cardAnimation = (index = 0) => ({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay: index * 0.1 },
});

export const smoothTransition = { duration: 0.6 };
export const smoothTransitionDelay = (delay = 0) => ({ duration: 0.6, delay });
export const springTransition = { duration: 0.7, delay: 0.2 };
export const springTransitionDelay = (delay = 0) => ({ duration: 0.7, delay });

export const floatingAnimation = {
  animate: { y: [0, -10, 0] },
  transition: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
};

export const floatingAnimationSlow = {
  animate: { y: [0, 10, 0] },
  transition: { duration: 4, repeat: Infinity, ease: 'easeInOut' },
};

export const pulseAnimation = {
  animate: { scale: [1, 1.05, 1] },
  transition: { duration: 2, repeat: Infinity },
};

export const navbarAnimation = {
  initial: { y: -100 },
  animate: { y: 0 },
};

export const mobileMenuAnimation = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
};
